import {Component, Prop, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import Loader from '@/components/Includes/Loader/Loader.vue';
import VpnForm from '@/components/Vpn/VpnForm/VpnForm';
import IVpn from '@/interfaces/vpns/IVpn';

@Component({
    name: 'VpnDetail',
    components: {
        Loader,
        CardHeader,
        VpnForm
    }
})
export default class VpnDetail extends Vue {
    @Action private updateVpn!: (form: IVpn) => Promise<void>;
    @Action private vpnRemove!: (id: number) => string;
    @Action private getVpn!: (id: string) => Promise<IVpn>;

    private vpnDataFromBackend: IVpn | null = null;

    private loading: boolean = false;

    private isEdit: boolean = false;

    private get vpnId() {
        return this.$route.params.id;
    }

    private get formData() {
        return this.vpnDataFromBackend;
    }

    private get btnIcon() {
        return !this.isEdit ? 'icon-pencil' : 'icon-lock';
    }

    private get editBtnText() {
        return !this.isEdit ? 'Edit' : 'Lock';
    }

    private editForm() {
        return (this.isEdit = !this.isEdit);
    }

    private vpnUpdate(form: IVpn) {
        this.updateVpn(form);
    }

    private async deleteVpn(id: number) {
        try {
            const approveRemove = confirm('Вы уверены что хотите удалить VPN?');

            if(approveRemove){
                const removeStatus = await this.vpnRemove(Number(id));

                if (removeStatus === 'deleted') {
                    this.$notify({
                        group: 'notice',
                        title: 'VPN',
                        text: 'Deleted Successfully',
                        type: 'success'
                    });

                    this.$router.push({name: 'vpns'});
                }
            }
        } catch (error) {
            throw new Error(error);
        }
    }

    private async created() {
        this.loading = true;

        try {
            this.vpnDataFromBackend = await this.getVpn(this.vpnId);
        } catch(error) {
           console.error(error);
        }
        this.loading = false;
    }
}
